import React from 'react';
import { Flex, Text, useTheme } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify';

const PhoneVerificationInstructions = ({ block1TranslationKey, block2TranslationKey }) => {
    const { tokens } = useTheme();

    return (
        <Flex direction="column" alignItems="center" gap={tokens.space.medium} marginTop={tokens.space.large}>
            {
                block1TranslationKey &&
                <Text
                    fontSize={tokens.fontSizes.medium}
                    color={tokens.colors.font.secondary}
                    textAlign="center"
                    maxWidth="400px"
                >
                    {I18n.get(block1TranslationKey)}
                </Text>
            }
            {
                block2TranslationKey &&
                <Text
                    fontSize={tokens.fontSizes.medium}
                    color={tokens.colors.font.secondary}
                    textAlign="center"
                    marginTop={tokens.space.medium}
                >
                    {I18n.get(block2TranslationKey)}
                </Text>
            }
        </Flex>
    );
};

export default PhoneVerificationInstructions;
